import { type JSX, createContext, useContext, useState } from 'react';

export interface NavContextValue {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
}

const NavContext = createContext<NavContextValue | undefined>(undefined);

export interface NavProviderProps {
    children: React.ReactNode;
    /** This is always true for SummIT users and false for third-party users. `FixedFooter` checks if the nav menu is open to determine whether it needs left margin to accommodate the width of the menu. */
    startClosed?: boolean;
}

export const NavProvider = ({ startClosed, children }: NavProviderProps): JSX.Element => {
    const [isOpen, setIsOpen] = useState(!!!startClosed);

    const value = { isOpen, setIsOpen };
    return <NavContext.Provider value={value}>{children}</NavContext.Provider>;
};

export const useNav = (): NavContextValue => {
    const context = useContext(NavContext);

    if (context === undefined) {
        throw new Error('useNav must be used within a NavProvider.');
    }
    return context;
};
